import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { toast } from "react-toastify";
import ConsultaModal from "../ConsultaModal";
import NovaConsultaModal from "../../Consultas/Components/NovaConsultaModal";

const TabelaParcelas = (props) => {
  const [modal, setModal] = useState(false);
  const [consultaEditavel, setconsultaEditavel] = useState(null);
  const [modalNovaConsulta, setModalNovaConsulta] = useState(false);

  const { id } = useParams();
  const cliente = props.cliente;

  const toggleModal = () => setModal(!modal);

  const [data, setData] = useState({
    columns: [
      { label: "ID", field: "id_consulta", sort: "asc", width: 150 },
      { label: "Data", field: "data", sort: "asc", width: 150 },
      { label: "Hora", field: "hora", sort: "asc", width: 150 },
      { label: "Cliente", field: "cliente", sort: "asc", width: 150 },
      { label: "Médico", field: "medico", sort: "asc", width: 150 },
      { label: "Área", field: "area", sort: "asc", width: 150 },
      { label: "Serviço", field: "servico", sort: "asc", width: 150 },
      { label: "Status", field: "status", sort: "asc", width: 150 },
      { label: "Mensagem", field: "observacao", sort: "asc", width: 150 },
    ],
    rows: [],
  });

  const formatarData = (data) => {
    const date = new Date(data);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const getConsultas = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/consultas/cliente/${id}`
      );
      const consultas = await response.json();
      setData((data) => ({
        ...data,
        rows: consultas.map((consulta) => ({
          data: formatarData(consulta.data),
          hora: consulta.hora,
          cliente: consulta.cliente,
          medico: consulta.medico,
          area: consulta.area,
          servico: consulta.servico,
          status: consulta.status,
          observacao: consulta.message,
          clickEvent: () => {
            setconsultaEditavel(consulta);
            setModal(true);
          },
        })),
      }));
    } catch (error) {
      console.error("Erro ao buscar consultas:", error);
    }
  };

  useEffect(() => {
    getConsultas();
  }, []);

  const handleOnClienteEdicao = (texto, type) => {
    if (type === "success") {
      toast.success(texto);
    } else {
      toast.error(texto);
    }
    getConsultas();
  };

  const adicionarConsulta = () => {
    setconsultaEditavel(null);
    setModalNovaConsulta(true);
  };

  return (
    <>
      <NovaConsultaModal
        isOpen={modalNovaConsulta}
        toggle={() => setModalNovaConsulta(!modalNovaConsulta)}
        cliente={cliente}
      />

      <ConsultaModal
        isOpen={modal}
        toggle={toggleModal}
        consultaEditavel={consultaEditavel}
        onClienteEdicao={handleOnClienteEdicao}
      />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Button color="primary" onClick={toggleModal}>
                Adicionar Parcela
              </Button>

              <Button color="primary" onClick={adicionarConsulta}>
                Adicionar nova consulta
              </Button>

              <MDBDataTable striped responsive bordered data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TabelaParcelas;
